// Gerado por `pnpm modules:sync` a partir dos module.json (ADR 0123). Não edite à mão.
import type { LocalizedText, PermissionDefinition } from '../permissions.ts';
import * as customers from './customers/index.ts';

/** Os módulos instalados, na ordem das dependências. */
export const INSTALLED_MODULES = [
  {
    id: 'customers',
    version: '1.0.0',
    name: { 'pt-BR': 'Clientes', en: 'Customers' },
    depends: [],
  },
] as const;

export const MODULE_PERMISSION_MODULES: Record<string, LocalizedText> = {
  ...customers.PERMISSION_MODULES,
};

export const MODULE_PERMISSIONS = [
  ...customers.PERMISSIONS,
] as const satisfies readonly PermissionDefinition[];
